import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Agendamento } from "../interfaces/entities/Agendamento";
import { HttpResponse } from "../interfaces/services/HttpResponse";
import { Response } from "../interfaces/services/Response";

export const getAgendamentos = async (): Promise<Agendamento[] | null> => {
    try {
        const response = await apiClientes.get('/Agenda/GetAgendamentos', {
            params: {
                latitude: 0,
                longitude: 0,
                start: 0,
                limit: 200,
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getAgendamentosTelemedicina = async (): Promise<Agendamento[] | null> => {
    try {
        const response = await apiClientes.get('/Agenda/GetAgendamentosTelemedicina', {
            params: {
                start: 0,
                limit: 10,
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const confirmarAgendamento = async (idInstal: number, idAgenda: number, nomePag: string): Promise<Response | null> => {
    try {
        const response = await apiClientes.post('/Agenda/ConfirmaAgenda', {
            idInstal: idInstal,
            idAgenda: idAgenda,
            nomePag: nomePag
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const cancelarAgendamento = async (idInstal: string, idAgenda: string): Promise<Response | null> => {
    try {
        const response = await apiClientes.post('/Agenda/CancelarAgendamento', {
            idInstal, idAgenda,
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const cancelarAtendimento = async (idAgenda: string, idInstal: string): Promise<Response | null> => {
    try {
        const response = await apiClientes.post('/Agenda/CancelarAgendamento', {
            idAgenda: idAgenda,
            idInstal: idInstal
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const getAgendamentosTeleorientacao = async (): Promise<Agendamento[] | null> => { //NOVA API
    try {
        const response = await apiClientes.get('/agenda/getagendamentosteleorientacao', {
            params: {
                start: 0,
                limit: 50,
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getAgendamentosTeleatendimento = async (): Promise<HttpResponse<Agendamento[]> | null> => { //NOVA API
    try {
        const response = await apiClientes.get('/agenda/getagendamentosteleatendimento', {
            params: {
                start: 0,
                limit: 10,
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};